import { cosemApi } from '@services/providers/cosem';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';
import { ETicket, ETicketToCreate, ETicketToImport } from './e-ticket.types';
import { ActiveFilter } from '@utils/filters';

const eTicketApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        postETicket: build.mutation<ApiResponse<ETicket>, ETicketToCreate>({
            query: (eticket: ETicketToCreate) => {
                return { 
                    url: `/product/eticket`, 
                    method: 'POST',
                    body: eticket
                };
            },
            transformResponse: (response: ApiResponse<ETicket>) => response
        }),
        putETicket: build.mutation<ApiResponse<ETicket>, { id: string; eticket: ETicketToCreate }>({
            query: ({ id, eticket }) => {
                return { 
                    url: `/product/eticket/${id}`, 
                    method: 'PUT',
                    body: eticket    
                };
            },
            transformResponse: (response: ApiResponse<ETicket>) => response
        }),

        getUnarchivedETickets: build.mutation<ApiPaginationResponse<ETicket>,
        { limit?: number; page?: number; search?: string; orderBy?: string; filters?: ActiveFilter[] }
        >({
            query: ({ limit = 10, page = 1, search, orderBy, filters }) => {
                return {
                    url: `/product/etickets`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '', filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiPaginationResponse<ETicket>) => response
        }),
        getArchivedETickets: build.mutation<ApiPaginationResponse<ETicket>,
        { limit?: number; page?: number; search?: string; orderBy?: string; filters?: ActiveFilter[] }
        >({
            query: ({ limit = 10, page = 1, search, orderBy, filters }) => {
                return {
                    url: `/product/etickets/archived`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '', filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiPaginationResponse<ETicket>) => response
        }),
        toggleArchiveETicket: build.mutation<ApiResponse<ETicket>, { id: string | number; archived: boolean }>({
            query: ({ id, archived }) => {
                return {
                    url: `/product/etickets/${id}/archive`,
                    method: 'PUT',
                    body: { archived }
                };
            },
            transformResponse: (response: ApiResponse<ETicket>) => response
        }),
        importETicket: build.mutation<ApiResponse<ETicket[]>, ETicketToImport>({
            query: (eticket: ETicketToImport) => {
                return {
                    url: `/product/eticket/import`,
                    method: 'POST',
                    body: eticket
                };
            },
            transformResponse: (response: ApiResponse<ETicket[]>) => response
        })  
    })
});

export const { 
    usePostETicketMutation,
    usePutETicketMutation,
    useGetUnarchivedETicketsMutation,
    useGetArchivedETicketsMutation,
    useToggleArchiveETicketMutation,
    useImportETicketMutation
} = eTicketApi;
